export const FIRESTORE_COLLECTIONS = {
	USERS: 'users',
}
